<script>
import { StripeCheckout } from 'vue-stripe-checkout'
import { purchaseMethods } from '@state/helpers'
import analyticsService from '@utils/analytics-service'

export default {
  components: {
    StripeCheckout,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showSubscriptions: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      publishableKey:
        process.env.NODE_ENV === 'production'
          ? 'pk_live_51I4oYSLdLmXu8X2rcsxzvhdvSueVjQ2AJeZDUph0W577EINndHRz28SX4dtQvUu0DYoncBd6JMhUKko3WnsUuSYV00jN6CvzQq'
          : 'pk_test_51I4oYSLdLmXu8X2rWcWQk5o7jBqos9W8DfHFzP2qfc7WS7dvIV2d85M6RiUaBLdPj5uYZeRuU45o9mmnPakw6hrO006Ov8NEZb',
      selectedItem: null,
      allPrices: [],
      sessionId: null,
      clicked: false,
      checkoutError: null,
    }
  },
  computed: {
    items() {
      return [this.selectedItem]
    },
    availablePrices() {
      return this.allPrices.filter(x => x.visible && x.mode === (this.showSubscriptions ? 'subscription': 'payment'))
    }
  },
  watch: {
    selectedItem: {
      handler() {
        this.tryCreateCheckoutSession()
      },
    },
  },
  created() {
    this.getAvailablePrices().then((prices) => {
      this.allPrices = prices
    })
  },
  methods: {
    ...purchaseMethods,
    async tryCreateCheckoutSession() {
      if (!this.selectedItem) {
        return
      }

      analyticsService.trackAction('User Chose Drops', this.selectedItem)
      const lineItems = [this.selectedItem.key]
      const res = await this.createCheckoutSession({ lineItems })
      this.sessionId = res.sessionId
    },
    checkout() {
      this.clicked = true
      analyticsService.trackAction('User Clicked Checkout')
      try {
        this.$refs.sessionRef.redirectToCheckout()
      } catch (err) {
        this.checkoutError =
          'Something went wrong initiating checkout. Brave has a known issue here. Please try Chrome or Safari.'
      }
    },
    onStripeError(e) {
      this.checkoutError = e.toString()
    },
  },
}
</script>

<template>
  <v-card>
    <v-card-title :class="$style.dialogTitle">
      <v-row justify="space-between">
        <v-col cols="9">
          {{ title }}
        </v-col>
        <v-col :class="$style.alignRight">
          <img
            :class="$style.stripeBadge"
            src="@assets/images/stripe_badge.png"
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text
      ><v-row>
        <v-col v-for="price in availablePrices" :key="price.key">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 12 : 2"
              :class="{ 'on-hover': hover }"
              @click="selectedItem = price"
            >
              <div :class="$style.priceCard">
                <div :class="$style.name">{{ price.name }}</div>
                <div :class="$style.price">{{ price.price }}</div>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row></v-card-text
    >
    <v-card-actions align="center">
      <div :class="$style.fillAndCenter">
        <v-row>
          <v-col>
            <div v-if="sessionId">
              <StripeCheckout
                ref="sessionRef"
                :pk="publishableKey"
                :session-id="sessionId"
                @error="onStripeError"
              >
                <template slot="checkout-button">
                  <BaseButton :class="$style.checkoutButton" @click="checkout">
                    <span>
                      Let's Go <BaseIcon v-if="clicked" name="sync" spin />
                    </span>
                  </BaseButton>
                </template>
              </StripeCheckout>
            </div>
            <div v-else>
              <strong>Please choose an option</strong>
            </div>
            <div v-if="checkoutError">
              <strong>{{ checkoutError }}</strong>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';

.priceCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 160px;
  cursor: pointer;
}

.name {
  font-weight: 300;
  font-size: 2rem;
  line-height: 2rem;
}

.price {
  font-weight: 500;
  font-size: 2.5rem;
  line-height: 2.5rem;
}

.dialogTitle {
  font-weight: 500;
  padding: 16px 24px 10px;
  line-height: 2rem;
  font-size: 1.25rem!important;
  letter-spacing: normal!important;
}

.checkoutButton {
  width: 100%;
  text-align: center;
}

.fillAndCenter {
  width: 100%;
  text-align: center;
}

.stripeBadge {
  height: 27px;
}

.alignRight {
  text-align: right;
}
</style>
